import React, { useState } from "react";

import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { View } from "../stores/ReportStore";
import AmplifyDashboard from "./dashboards/Amplify.react";
import VimeoEmbed from "./dashboards/VimeoEmbed.react";
import FilterableTableauViz from "./FilteredTableauViz.react";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const displayExternalDoc = (content) => {
  const contentType = content.split(".").at(-1)
  switch (contentType) {
    case "pdf":
      return <iframe style={{ height: "100%" }} src={content} />
    case "doc": case "docx": case "ppt": case "pptx": case "xls": case "xlsx":
      const doc = [{ uri: content, fileType: contentType }]
      return <DocViewer pluginRenderers={DocViewerRenderers} documents={doc} style={{ height: "100%" }}/>
    default:
      return <iframe style={{ height: "100%" }} src={content} />
  }

}

const renderOptions = (content) => ({
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      const entry = content.getIn(["entries", node.data.target.sys.id]);
      if (!entry) {
        console.log(`Failed to find entry with ID ${node.data.target.sys.id}`);
        return <param>Content missing</param>;
      }
      const contentType = entry.getIn(["sys", "contentType", "sys", "id"]);
      switch (contentType) {
        case "externalDashboard":
          /** @type {String} */
          const url = entry.getIn(["fields", "url"]);
          if (url == "https://bigal.media/") {
            return (
              <AmplifyDashboard
                url={url}
                config={entry.getIn(["fields", "configuration"])}
              />
            );
          } else if (url.includes("vimeo.com")) {
            return <VimeoEmbed url={url} />;
          }
          return (
            <iframe
              src={url}
              sandbox="allow-scripts allow-popups allow-forms"
            />
          );
        case "dashboard":
          const tableauId = entry.getIn(["fields", "tableauId"]);
          const view = new View({ viewPath: tableauId });
          const filterOptions = entry.getIn(
            ["fields", "contentFilter", "options"],
            null
          );
          return (
            <FilterableTableauViz
              view={view}
              filterOptions={filterOptions}
              tableauOptions={{ hideTabs: false }}
            />
          );

        default:
          console.log(`Unknown or unsupported content type ${contentType}`);
          return <p>Unknown or unsupported content type.</p>;
      }
    },
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const asset = content.getIn(["assets", node.data.target.sys.id]);
      const url = asset && asset.getIn(["fields", "file", "url"]);
      const contentType = asset && asset.getIn(["fields", "file", "contentType"])
      return contentType.startsWith("image") ?
        (
          <img
            src={`https:${url}`}
            style={{ maxWidth: "75%", width: "max-content" }}
          />
        ) :
        displayExternalDoc(url)
        ;
    },
    [INLINES.ASSET_HYPERLINK]: (node, children) => {
      const asset = content.getIn(["assets", node.data.target.sys.id]);
      const url = asset && asset.getIn(["fields", "file", "url"]);
      return <a href={url}>{children}</a>;
    },
  },
});

const renderContent = (page, content) =>
  documentToReactComponents(page, renderOptions(content));

export default renderContent;
